var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4053",
    "data-name": "Group 4053",
    transform: "translate(-174 -1896)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(174 1896)",
    fill: "#24397a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "receipt_long-24px",
    transform: "translate(190 1912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M0,0H48V48H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1331",
    "data-name": "Group 1331",
    transform: "translate(6 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M36,5,33,2,30,5,27,2,24,5,21,2,18,5,15,2,12,5,9,2V30H3v6a5.992,5.992,0,0,0,6,6H33a5.992,5.992,0,0,0,6-6V2ZM27,38H9a2.006,2.006,0,0,1-2-2V34H27Zm8-2a2,2,0,1,1-4,0V30H13V8H35Z",
    transform: "translate(-3 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M-22.514-91.215a5.439,5.439,0,0,1-.558,1.9,5.8,5.8,0,0,1-1.1,1.493,6.267,6.267,0,0,1-1.508,1.086,8.631,8.631,0,0,1-1.75.679l7.21,9.5H-23.66L-29-83.643a8.365,8.365,0,0,0-1.584-1.7,2.462,2.462,0,0,0-1.493-.528v-2.2h1.78a11.5,11.5,0,0,0,1.795-.136,5.3,5.3,0,0,0,1.554-.483,3.337,3.337,0,0,0,1.161-.95,2.956,2.956,0,0,0,.558-1.569H-32.62l.905-1.78h6.365a3.479,3.479,0,0,0-1.177-1.991A3.951,3.951,0,0,0-28.97-95.8h-3.65l.905-1.78h13.243l-.905,1.78h-4.4a5.053,5.053,0,0,1,1.237,2.806h4.073l-.905,1.78Z",
    transform: "translate(45.854 105.238)",
    fill: "none"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceBg);
export default __webpack_public_path__ + "static/media/invoice-bg.289a9fc2b1bdaf2d376b3cadfa06dee3.svg";
export { ForwardRef as ReactComponent };